<div *ngIf="isMaster || isMasterAssociate" class="flex justify-between items-center">
    <span class="stock-title">Estoque de câmeras e detecções</span>
    <span *ngIf="inventory" (click)="openUpdateModal()" class="edit-button flex items-center"><span style="margin-right: 4px;" nz-icon nzType="edit" nzTheme="outline"></span>Editar estoque</span>
</div>
<div class="background" *ngIf="inventory">
    <table class="quantity-table">
        <thead>
            <th></th>
            <th class="col-1 text-center">Total</th>
            <th class="col-1 text-center">
                <div class="flex items-center">
                    Distribuídas
                    <span class="info-icon clickable" nz-icon nzType="exclamation-circle" nzTheme="outline" 
                        nz-tooltip nzTooltipTitle="Detecções inteligentes que já foram distribuídas aos clientes, independente da quantidade de câmeras cadastradas"
                        nzTooltipOverlayClassName="camera_playlist_processing" nzTooltipPlacement="top">
                    </span>
                </div>
            </th>
            <th class="col-1 text-center"></th>
            <th class="col-1 text-center">Disponível</th>
        </thead>
        <tbody>
            <tr>
                <td style="width: 47%;">Detecções Inteligentes</td>
                <td class="text-center">{{inventory.inventory.ai.used + inventory.inventory.ai.available}}</td>
                <td class="text-center">{{inventory.inventory.ai.used}}</td>
                <td>
                    <div class="progress-container">
                        <app-progress-bar [progress]="(inventory.inventory.ai.used/(inventory.inventory.ai.used + inventory.inventory.ai.available))*100"></app-progress-bar>
                    </div>
                </td>
                <td class="text-center">{{inventory.inventory.ai.available}}</td>
            </tr>
        </tbody>
    </table>
    
    <div class="filter-container">
        <div class="filter" [ngClass]="{'running': filter.length > 0}" (click)="onFilterClick()">
            <span class="filter-icon" nz-icon nzType="video-camera" nzTheme="outline"></span>
            <span>Filtrar por plano</span>
            <i class="material-icons down" style="color: #6CACFF;">expand_more</i>
            <i class="material-icons up" style="color: #6CACFF;">expand_less</i>
        </div>
        <div class="clear-filter" *ngIf="filter.length > 0">
            <span (click)="clearFilter()">Limpar filtro</span>
        </div>
        <div class="open-filter">
            <ul class="categories">
                <li *ngFor="let item of filterList" (click)="toggleSelection(item, $event)" [id]="item.resolution">
                    <div class="flex-container between">
                        <span style="text-transform: uppercase;">Câmera {{item.resolution}}</span>
                        <i class="material-icons right">chevron_right</i>
                        <i class="material-icons left">chevron_left</i>
                    </div>
                </li>
            </ul>
            <ul class="select">
                <li *ngFor="let item of possibleSelections" (click)="toggleFilter(item, $event)" [ngClass]="{'selected': item.selected}">
                    <div class="flex-container start">
                        <i class="material-icons uncheck" style="margin-right: 16px">check_box_outline_blank</i>
                        <i class="material-icons check" style="margin-right: 16px">check_box</i>
                        <span>{{item.days_storage}} {{item.days_storage == 1 ? ' dia' : ' dias'}}</span>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <table mat-table [dataSource]="cameraList" *ngIf="cameraList" class="style-table">
        <ng-container matColumnDef="plan">
            <th mat-header-cell *matHeaderCellDef>Plano</th>
            <td mat-cell *matCellDef="let camera">CÂMERA {{camera.alias}} <span>{{camera.days_storage}} {{camera.days_storage == 1 ? ' dia' : ' dias'}}</span></td>
        </ng-container>
        <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef class="col-1 text-center">Total</th>
            <td mat-cell *matCellDef="let camera" class="text-center">{{camera.available+camera.used}}</td>
        </ng-container>
        <ng-container matColumnDef="using">
            <th mat-header-cell *matHeaderCellDef class="col-1 text-center">
                <div class="flex items-center">
                    Distribuídas
                    <span class="info-icon clickable" nz-icon nzType="exclamation-circle" nzTheme="outline" 
                        nz-tooltip nzTooltipTitle="Detecções inteligentes que já foram distribuídas aos clientes, independente da quantidade de câmeras cadastradas"
                        nzTooltipOverlayClassName="camera_playlist_processing" nzTooltipPlacement="top"
                        [nzTooltipOverlayStyle]="{'margim-bottom': '12px'}">
                    </span>
                </div>
            </th>
            <td mat-cell *matCellDef="let camera" class="text-center">{{camera.used}}</td>
        </ng-container>
        <ng-container matColumnDef="graph">
            <th mat-header-cell *matHeaderCellDef class="col-1 text-center"></th>
            <td mat-cell *matCellDef="let camera" class="text-center">
                <div class="progress-container">
                    <app-progress-bar [progress]="(camera.used / (camera.used + camera.available)) * 100"></app-progress-bar>
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="available">
            <th mat-header-cell *matHeaderCellDef class="col-1 text-center">Disponível</th>
            <td mat-cell *matCellDef="let camera" class="text-center">{{camera.available}}</td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let camera; columns: tableColumns"></tr>
    </table>

    <div class="no-camera" [hidden]="cameraList != undefined">
        <span>Ainda não há cameras disponíveis</span>
    </div>
</div>

<div class="center-spinner" *ngIf="!inventory">
    <span nz-icon nzType="loading" nzTheme="outline" style="font-size:50px"></span>
</div>
<app-modal></app-modal>